import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { FilterKey, TabKey } from '@/routes/_staff/people/_list/workforce/-constants';
import { SortColumns } from './-constants';
export const SearchSchema = z.object({
  freeText: z.string().optional(),
  softwareIds: z.array(z.string()).optional(),
  contractTypeIds: z.array(z.string()).optional(),
  placeIds: z.array(z.string()).optional(),
  menu: z.nativeEnum(TabKey).default(TabKey.EMPLOYEE),
  category: z.nativeEnum(FilterKey).default(FilterKey.EMPLOYEE_ALL),
  pageIndex: z.number().int().nonnegative().default(0),
  pageSize: z.number().int().positive().default(100),
  sortColumn: z.enum(SortColumns).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;